import { useAppSelector } from '~/common/stores';

import type { ClassRequest } from '~/features/matching/types/matching.type';

/**
 * 매칭 상태 구독 훅.
 * @description fetch 는 **페이지 useEffect 에서만** 하고(fetch-in-page-only), 하위 컴포넌트는 이 훅으로
 *  구독만 한다 — hoya-admin 계승 규약. 상태 파생(대기중/진행중 분리)을 화면마다 반복하면 조건이
 *  어긋나므로 여기서 한 번만 계산한다.
 */
function useMatching() {
  const state = useAppSelector(state => state.matching);

  // 시안 홈은 두 섹션을 별도 카드로 그리지만 원본은 같은 레코드다 — 상태로만 가른다.
  const pendingRequests = state.requests.filter(item => item.status === 'pending');
  const activeRequests = state.requests.filter(item => item.status === 'active');

  // 지도사 콘솔은 축이 다른 목록(나에게 들어온 신청)을 같은 방식으로 가른다.
  const pendingTutorRequests = state.tutorRequests.filter(item => item.status === 'pending');
  const activeTutorRequests = state.tutorRequests.filter(item => item.status === 'active');

  // 완료된 수업 — 보호자에게는 후기를 남길 대상, 지도사에게는 지난 수업이다.
  const completedRequests = state.requests.filter(item => item.status === 'completed');
  const completedTutorRequests = state.tutorRequests.filter(item => item.status === 'completed');

  const totalUnread = state.rooms.reduce((sum, room) => sum + room.unreadCount, 0);

  return {
    ...state,
    pendingRequests,
    activeRequests,
    pendingTutorRequests,
    activeTutorRequests,
    completedRequests,
    completedTutorRequests,
    totalUnread,
  };
}

/** 신청 1건이 어느 방에 대응하는지 — 채팅 진입 경로를 신청에서 역으로 찾을 때 쓴다. */
export function findRoomByRequest(
  rooms: { requestId: string; id: string }[],
  request: ClassRequest,
) {
  return rooms.find(room => room.requestId === request.id);
}

export default useMatching;
